import { useEffect, useState } from 'react';
import {
  listContainerSizes,
  listContainerTypes,
  listJobTypes,
  listSpecialHandlingRequirements,
  type ContainerSize,
  type ContainerType,
  type JobType,
  type SpecialHandlingRequirement,
} from '../../reference-data/reference-data.api';

export type JobCataloguesState =
  | { status: 'loading' }
  | {
      status: 'loaded';
      jobTypes: JobType[];
      containerSizes: ContainerSize[];
      containerTypes: ContainerType[];
      specialHandlingRequirements: SpecialHandlingRequirement[];
    }
  | { status: 'error' };

/** The job-type, container size/type and special handling selects the intake form fills — active-only, fetched once (CLAUDE.md's small-fixed-catalogue exception to server-side paging). Zones search the server instead (ZoneSearchSelect). */
export function useJobCatalogues(): JobCataloguesState {
  const [state, setState] = useState<JobCataloguesState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    Promise.all([listJobTypes(), listContainerSizes(), listContainerTypes(), listSpecialHandlingRequirements()])
      .then(([jobTypes, containerSizes, containerTypes, specialHandlingRequirements]) => {
        if (!cancelled) {
          setState({
            status: 'loaded',
            jobTypes: jobTypes.filter((t) => t.isActive),
            containerSizes: containerSizes.filter((s) => s.isActive),
            containerTypes: containerTypes.filter((t) => t.isActive),
            specialHandlingRequirements: specialHandlingRequirements.filter((r) => r.isActive),
          });
        }
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
